import { getComponent as t, getCustomFallbackComponent as r, getEnableFallbackComponent as l, useStoryblokApi as a, setComponents as i, storyblokInit as s, useStoryblokApi as b } from "./index2.mjs";
import { default as k } from "./story.mjs";
import { default as p, default as g } from "./bridge-loader.mjs";
import { default as m } from "./storyblok-component.mjs";
import { RichTextResolver as f, RichTextSchema as u, apiPlugin as x, loadStoryblokBridge as c, registerStoryblokBridge as B, renderRichText as C, storyblokEditable as h, registerStoryblokBridge as R } from "./storyblok-js.mjs";
export {
  p as BridgeLoader,
  f as RichTextResolver,
  u as RichTextSchema,
  g as StoryblokBridgeLoader,
  m as StoryblokComponent,
  k as StoryblokStory,
  x as apiPlugin,
  t as getComponent,
  r as getCustomFallbackComponent,
  l as getEnableFallbackComponent,
  a as getStoryblokApi,
  c as loadStoryblokBridge,
  B as registerStoryblokBridge,
  C as renderRichText,
  i as setComponents,
  h as storyblokEditable,
  s as storyblokInit,
  b as useStoryblokApi,
  R as useStoryblokBridge
};
